import { useEffect, useState } from "react";
import { useActaDetalleStore } from "../../../../../store/actaDetalleStore";
import Video from "../../../../../components/Icons/Video";
import ReloadIcon from "../../../../../components/Icons/RealodIcon";
import PrevImagen from "./PrevImagen";
import './style.css'

const TabImagenes = () => {
    const { actaDetalle } = useActaDetalleStore();
    const { archivos } = actaDetalle;

    
    const [imagenSelect, setImagenSelect] = useState(
        archivos?.fotos_comprimidas
            ? archivos?.fotos_comprimidas[0]?.file
            : archivos?.fotos[0]?.file
    );
    const [isGifSelected, setIsGifSelected] = useState(false);

    useEffect(() => {
        if (archivos?.fotos_comprimidas) {
            setImagenSelect(archivos?.fotos_comprimidas[0]?.file)
        } else {
            setImagenSelect(archivos?.fotos[0]?.file)
        }
    }, [archivos])

    return (
        <div>
            {/* <h6 className="m-0 ps-2 pe-5 mb-2 text-light bg-primary py-1" style={{ borderBottom: "1px solid gray", width: "fit-content", lineHeight: "14px" }}>Fotos y video de infracción</h6> */}
            <section className="d-flex flex-column align-items-center gap-1 ">
                {/* Thumbnails */}
                {
                    <div
                        className=" w-100">
                        {
                            <PrevImagen isGifSelected={isGifSelected} imagenSelect={imagenSelect} setImagenSelect={setImagenSelect} gifAux={archivos?.video?.file} video={archivos?.video?.file} />
                        }
                    </div>
                }
                <div className="d-flex  justify-content-start flex-wrap gap-3 " >
                    {archivos?.fotos_comprimidas?.map((foto, index) => (
                        <div
                            key={index}
                            className={` ${imagenSelect === foto.file && !isGifSelected && "border border-2 border-primary"}`}
                            style={{
                                width: "50px",
                                aspectRatio: '4/3',
                                backgroundColor: "rgba(17,52,201,0.3)",
                            }}
                            onClick={() => {
                                setImagenSelect(foto.file);
                                setIsGifSelected(false);
                            }}
                        >
                            <img src={foto.file} alt="foto" className="w-100 h-100" style={{ objectFit: "contain" }} />
                        </div>
                    ))}
                    {archivos?.fotos?.map((foto, index) => (
                        <div
                            key={index}
                            className={`col-6 ${imagenSelect === foto.file && !isGifSelected && "border border-2 border-primary"} `}
                            style={{
                                width: "50px",
                                aspectRatio: '4/3',
                                backgroundColor: "rgba(17,52,201,0.3)",
                                cursor: "pointer"

                            }}
                            onClick={() => {
                                setImagenSelect(foto.file);
                                setIsGifSelected(false);
                            }}
                        >
                            <img src={foto.file} alt="foto" className="w-100 h-100 miniImg" style={{ objectFit: "contain" }} />
                        </div>
                    ))}
                    {/* Video Thumbnail */}
                    {
                        archivos?.video &&
                        <div
                            style={{
                                width: "50px",
                                height: "50px",
                                backgroundColor: "#d9d9d9",
                                cursor: "pointer"
                            }}
                            className="d-flex flex-column justify-content-center align-items-center miniImg"
                            onClick={() => {
                                setImagenSelect(archivos.video.file);
                                setIsGifSelected(true);
                            }}
                        >
                            <Video width="25px" height="25px" color="#111" />
                            {/* <span className="fw-bold text-light " style={{ fontSize: "12px" }}>VIDEO</span> */}
                        </div>
                    }
                </div>


            </section>
        </div>
    );
};

export default TabImagenes;
